var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.719 8.984c.009 4.803-3.909 8.731-8.713 8.735-2.074.001-3.98-.722-5.478-1.93-.39-.315-.418-.899-.064-1.253l.396-.396c.302-.302.786-.335 1.12-.07 1.104.876 2.5 1.399 4.02 1.399 3.576 0 6.469-2.894 6.469-6.469 0-3.576-2.894-6.469-6.469-6.469-1.716 0-3.275.667-4.432 1.756L6.352 6.07c.355.354.104.96-.397.96H.844c-.31 0-.563-.252-.563-.562V1.358c0-.501.606-.752.96-.398l1.736 1.736C4.543 1.2 6.664.281 9 .281c4.81 0 8.71 3.895 8.719 8.703zm-6.36 2.77l.345-.445c.286-.368.22-.898-.148-1.184l-1.431-1.113V5.344c0-.466-.378-.844-.844-.844H8.72c-.466 0-.844.378-.844.844v4.769l2.3 1.788c.367.286.897.22 1.184-.148z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClock);
export default __webpack_public_path__ + "static/media/arrow-clock.3c80255c4fa8a8df966e70c1ccbd19c8.svg";
export { ForwardRef as ReactComponent };